import { lazy, Suspense } from "react";
import type { NetworkEventRow } from "@/api/schemas/monitor";

const MonitorAlertChartImpl = lazy(
  () => import("./monitor-alert-chart-impl"),
);

export interface MonitorAlertChartProps {
  rows: NetworkEventRow[];
  cachedAt: string | null;
}

export function MonitorAlertChart(props: MonitorAlertChartProps) {
  return (
    <Suspense fallback={null}>
      <MonitorAlertChartImpl {...props} />
    </Suspense>
  );
}
